import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { useNavigate } from "react-router";
const BackBtn = ({
  navigatePath = "",
  navigation = true,
  onClick = () => {},
}) => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex align-items-center gap-2 text-primarycolor fs18 cursor-pointer"
      onClick={navigation ? () => navigate(navigatePath) : onClick}
    >
      <MdOutlineKeyboardBackspace />
      <span>Back</span>
    </div>
  );
};

export default BackBtn;
